<h2 mat-dialog-title>Correção do Questionário</h2>
<mat-dialog-content>

    <span class="helper" *ngIf="!canConclude()">Avalie todas as repostas para poder concluir a avaliação desse questionário</span>
    <ng-container *ngFor="let question of questions; let i = index">

        <div class="question">
            <h3 class="mat-h3">{{ question.description }}</h3>
            <p style="color: #093">Resposta(s) do candidato</p>

            <ng-container *ngIf="question.question_type === 'dissertative'">

                <mat-list>
                    <mat-list-item>
                        <h3 matLine>{{ getAnsweredQuestion(question)[0]?.response }}</h3>
                        <button mat-icon-button color="primary" matTooltip="Aprovar resposta" 
                            (click)="approveResponse(getAnsweredQuestion(question)[0], true)"
                            [ngClass]="{ selected: corrections[getAnsweredQuestion(question)[0]?.id] == true }"
                            [disabled]="question.evaluated === '1'">
                            <mat-icon>thumb_up</mat-icon>
                        </button>
                        <button mat-icon-button color="accent" matTooltip="Rejeitar resposta" 
                            (click)="approveResponse(getAnsweredQuestion(question)[0], false)"
                            [ngClass]="{ selected: corrections[getAnsweredQuestion(question)[0]?.id] == false }"
                            [disabled]="question.evaluated == 1">
                            <mat-icon>thumb_down</mat-icon>
                        </button>
                    </mat-list-item>
                </mat-list>

            </ng-container>
            <ng-container *ngIf="question.question_type === 'option'">

                <mat-list>
                    <mat-list-item *ngFor="let option of getAnsweredQuestion(question)">
                    <!-- <mat-list-item *ngFor="let option of getAnsweredQuestion(question)" [matTooltip]="option.evaluated == 1?'Pergunta corrigida, nenhuma ação é necessária.':''"> -->
                        <h3 matLine>{{ option.description }}</h3>
                        <!-- <button mat-icon-button color="primary" matTooltip="Aprovar resposta"
                        [ngClass]="{ selected: corrections[option.id] == true }"
                            (click)="approveResponse(option, true)"
                            [disabled]="option.evaluated == 1">
                            <mat-icon>thumb_up</mat-icon>
                        </button>
                        <button mat-icon-button color="accent" matTooltip="Rejeitar resposta" 
                            [ngClass]="{ selected: corrections[option.id] == false }"
                            (click)="approveResponse(option, false)"
                            [disabled]="option.evaluated == 1">
                            <mat-icon>thumb_down</mat-icon>
                        </button> -->
                    </mat-list-item>
                </mat-list>

            </ng-container>
            <ng-container *ngIf="question.question_type === 'multiple'">

                <mat-list>
                    <!-- <mat-list-item *ngFor="let option of getAnsweredQuestion(question)" [matTooltip]="option.evaluated == 1?'Pergunta corrigida, nenhuma ação é necessária.':''"> -->
                    <mat-list-item *ngFor="let option of getAnsweredQuestion(question)">
                        <h3 matLine>{{ option.description }}</h3>
                        <!-- <button mat-icon-button color="primary" matTooltip="Aprovar resposta"
                        [ngClass]="{ selected: corrections[option.id] == true }"
                            (click)="approveResponse(option, true)"
                            [disabled]="option.evaluated == 1">
                            <mat-icon>thumb_up</mat-icon>
                        </button>
                        <button mat-icon-button color="accent" matTooltip="Rejeitar resposta" 
                            [ngClass]="{ selected: corrections[option.id] == false }"
                            (click)="approveResponse(option, false)"
                            [disabled]="option.evaluated == 1">
                            <mat-icon>thumb_down</mat-icon>
                        </button> -->
                    </mat-list-item>
                </mat-list>

            </ng-container>

        </div>

    </ng-container>

    

</mat-dialog-content>
<mat-dialog-actions>
    <button color="accent" mat-dialog-close mat-button>Fechar</button>
    <div>
        <button color="primary" mat-raised-button (click)="conclude(true)" [disabled]="!canConclude()">Concluir</button>
    </div>
</mat-dialog-actions>